import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const SPEC_CATEGORIES = [
  'saas',
  'marketplace',
  'social',
  'productivity',
  'developer-tools',
  'ecommerce',
  'other',
] as const;

export type SpecCategory = (typeof SPEC_CATEGORIES)[number];

export const CATEGORY_LABELS: Record<string, string> = {
  saas: 'SaaS',
  marketplace: 'Marketplace',
  social: 'Social',
  productivity: 'Productivity',
  'developer-tools': 'Developer Tools',
  ecommerce: 'E-commerce',
  other: 'Other',
};

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 64);
}

export const COMPLEXITY_COLORS: Record<string, string> = {
  low: 'text-green-700 bg-green-50 border-green-200',
  medium: 'text-yellow-700 bg-yellow-50 border-yellow-200',
  high: 'text-red-700 bg-red-50 border-red-200',
};

export const DIMENSION_LABELS: Record<string, string> = {
  cost: 'Cost',
  latency: 'Latency',
  complexity: 'Complexity',
  scalability: 'Scalability',
  ux: 'UX',
};
